// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"8b4923f3","762":"dd33a8ea"}[chunkId] + ".chunk.css";
};